module.exports = __webpack_public_path__ + "static/bobby-1929a1fcb2edb3bcf91d5f07cf8a778a.svg";